<!-- image -->
<image-quiz
    [slide]="slide">
</image-quiz>

<!-- content -->
<p *ngFor="let p of slide.content" [innerHtml]="p.text"></p>